import axios from "axios";

export default {
  getShareByUserAndUuid(uuid) {
    return axios({
      method: "get",
      url: process.env.VUE_APP_BASE_URL_CORE + "auth/nosql/share/" + uuid,
      headers: {
        authorization: localStorage.getItem("authorization"),
      },
    });
  },
  save(data) {
    return axios({
      method: "post",
      data: data,
      url: process.env.VUE_APP_BASE_URL_CORE + "auth/nosql/share",
      headers: {
        authorization: localStorage.getItem("authorization"),
      },
    });
  },
  delete(id) {
    return axios({
      method: "delete",
      url: process.env.VUE_APP_BASE_URL_CORE + "auth/share/" + id,
      headers: {
        authorization: localStorage.getItem("authorization"),
      },
    });
  },
  get(id) {
    return axios({
      method: "get",
      url: process.env.VUE_APP_BASE_URL_CORE + "auth/share/" + id,
      headers: {
        authorization: localStorage.getItem("authorization"),
      },
    });
  },
  getAllByPatient(currentPage = 0, pageSize = 10, patientId) {
    return axios({
      method: "get",
      url:
        process.env.VUE_APP_BASE_URL_CORE +
        "auth/shares/patient/" +
        patientId +
        "?page=" +
        currentPage +
        "&size=" +
        pageSize,
      headers: {
        authorization: localStorage.getItem("authorization"),
      },
    });
  },
  getAllVideoconference(currentPage = 0, pageSize = 10, patientId) {
    return axios({
      method: "get",
      url:
        process.env.VUE_APP_BASE_URL_CORE +
        "auth/shares/videoconference/patient/" +
        patientId +
        "?page=" +
        currentPage +
        "&size=" +
        pageSize,
      headers: {
        authorization: localStorage.getItem("authorization"),
      },
    });
  },
  getAllHistoric(currentPage = 0, pageSize = 10, patientId) {
    return axios({
      method: "get",
      url:
        process.env.VUE_APP_BASE_URL_CORE +
        "auth/shares/historic/patient/" +
        patientId +
        "?page=" +
        currentPage +
        "&size=" +
        pageSize,
      headers: {
        authorization: localStorage.getItem("authorization"),
      },
    });
  },
  getAll(currentPage = 0, pageSize = 10) {
    return axios({
      method: "get",
      url:
        process.env.VUE_APP_BASE_URL_CORE +
        "auth/shares?page=" +
        currentPage +
        "&size=" +
        pageSize,
      headers: {
        authorization: localStorage.getItem("authorization"),
      },
    });
  },
  create(data) {
    return axios({
      method: "post",
      data: data,
      url: process.env.VUE_APP_BASE_URL_CORE + "auth/share",
      headers: {
        authorization: localStorage.getItem("authorization"),
      },
    });
  },
  update(data) {
    return axios({
      method: "put",
      data: data,
      url: process.env.VUE_APP_BASE_URL_CORE + "auth/share",
      headers: {
        authorization: localStorage.getItem("authorization"),
      },
    });
  },
};
